import React, { useState, useEffect } from 'react';
import { TLoaderType } from 'types';
import { getS3FilePath } from 'utils/helpers';
import { useBlobDownload } from 'hooks/useBlobDownload';
import LoaderWithProps from 'components/Loader/LoaderWithProps';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './ImgUploader.module.scss';

interface IProps {
	loaderSize: TLoaderType;
	preSignedUrl?: Nullable<string>;
	noImageIdIcon?: string;
}

export const ImgUploaderByPreSignedUrl: React.FC<IProps> = React.memo(
	({ loaderSize, preSignedUrl, noImageIdIcon = 'menu' }) => {
		const [isLoading, setIsLoading] = useState<boolean>(false);
		const [actualPath, setActualPath] = useState<string>('');
		const blobDownload = useBlobDownload({
			filePath: preSignedUrl ? getS3FilePath(preSignedUrl) : null,
			fileExtension: 'jpg',
			fileName: 'image',
		});

		const showError = () => {
			setActualPath('error');
			setIsLoading(false);
		};

		useEffect(() => {
			if (preSignedUrl) {
				setIsLoading(true);
				setActualPath(preSignedUrl);
			}
		}, [preSignedUrl]);

		return (
			<div className={style.container} data-test="ImgUploaderByFilePath">
				{isLoading ? <LoaderWithProps loaderSize={loaderSize} /> : null}
				{actualPath !== 'error' && actualPath && (
					<div className={style.imgWrapper}>
						{preSignedUrl && (
							<div onClick={blobDownload} className={style.downloadOverlay}>
								<svg className={style.downloadIcon}>
									<use xlinkHref={`${breadcrumbs}#downloadArrow`} />
								</svg>
							</div>
						)}
						<img
							className={style.img}
							src={actualPath}
							onLoad={() => setIsLoading(false)}
							onError={showError}
							alt="Photo"
						/>
					</div>
				)}
				{actualPath === '' && (
					<div className={style.noImage}>
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#${noImageIdIcon}`} />
						</svg>
					</div>
				)}
				{actualPath === 'error' && (
					<div className={style.noImage}>
						<div className={style.flexColumn}>
							<svg className={style.iconError}>
								<use xlinkHref={`${breadcrumbs}#brokenPicture`} />
							</svg>
							<div>Error image</div>
						</div>
					</div>
				)}
			</div>
		);
	},
);
